"use client";

import { c as _c } from "react/compiler-runtime";
import GridRow from "../common/grid-row/grid-row";
import GridColumn from "../common/grid-column/grid-column";
import Link, { LinkStyle, LinkType } from "../common/link/link";
import ArrowIcon from "../common/arrow-icon/arrow-icon";
import CurvedUnderline from "@/components/common/curved-underline/curved-underline";
import HomeAds from "./home-ads";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import { ToolsGrid } from "@/sanity/sanity.types";
interface HeroProps {
  hero: any;
  heroHeight: number;
  As146linkTextName?: string;
}
const HeroComponent = t0 => {
  const $ = _c(47);
  const {
    hero,
    heroHeight,
    As146linkTextName
  } = t0;
  let t1;
  if ($[0] !== hero.background) {
    t1 = hero.background?.asset ? `url(${imageUrl(hero.background.asset).url()})` : undefined;
    $[0] = hero.background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${heroHeight}px`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      backgroundImage: t1,
      height: t2,
      minHeight: "631px"
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HomeAds />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hero.headline) {
    t5 = <h1>{hero.headline}</h1>;
    $[6] = hero.headline;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hero.subhead) {
    t6 = <p className="text-xl">{hero.subhead}</p>;
    $[8] = hero.subhead;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== As146linkTextName || $[11] !== hero.options) {
    t7 = hero.options?.slice(0, 2).map((option, index) => <Link key={index} href={option.cta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={index > 0 ? LinkStyle.SECONDARY : LinkStyle.PRIMARY} className="!w-full border-2 border-solid border-[#00698F]">{index === 0 && As146linkTextName ? As146linkTextName : option.cta.link.label}</Link>);
    $[10] = As146linkTextName;
    $[11] = hero.options;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="grid max-w-fit grid-cols-2 gap-4">{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== hero.secondaryCta) {
    t9 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""} className="group relative"><span>{hero.secondaryCta.link.label}</span><ArrowIcon /><CurvedUnderline /></Link>;
    $[15] = hero.secondaryCta;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t8 || $[20] !== t9) {
    t10 = <GridRow><GridColumn lg={7}><div className="flex w-full flex-col gap-6 rounded-2xl bg-[#f2f2f2] px-14 py-10">{t4}{t5}{t6}{t8}{t9}</div></GridColumn></GridRow>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3) {
    t11 = <div className="m-auto !hidden min-h-[631px] !max-w-[1440px] items-center bg-center bg-no-repeat md:!flex" style={t3}>{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== hero.background || $[26] !== hero.headline) {
    t12 = hero.background?.asset && <Image className="w-full md:!hidden" src={imageUrl(hero.background.asset).height(200).url()} alt={hero.headline ?? ""} width={609} height={200} fetchPriority="high" />;
    $[25] = hero.background;
    $[26] = hero.headline;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HomeAds />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== hero.headline) {
    t14 = <h1>{hero.headline}</h1>;
    $[29] = hero.headline;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== hero.subhead) {
    t15 = <h4 className="text-base !font-medium">{hero.subhead}</h4>;
    $[31] = hero.subhead;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== As146linkTextName || $[34] !== hero.options) {
    t16 = hero.options?.slice(0, 2).map((option_0, index_0) => <Link key={index_0} href={option_0.cta.link.href ?? ""} linkType={LinkType.BUTTON} linkStyle={index_0 > 0 ? LinkStyle.SECONDARY : LinkStyle.PRIMARY} className="!w-full border-2 border-solid border-[#00698F]">{index_0 === 0 && As146linkTextName ? As146linkTextName : option_0.cta.link.label}</Link>);
    $[33] = As146linkTextName;
    $[34] = hero.options;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== hero.secondaryCta) {
    t17 = hero.secondaryCta?.link && <Link href={hero.secondaryCta.link.href ?? ""}><span>{hero.secondaryCta.link.label}</span><ArrowIcon /></Link>;
    $[36] = hero.secondaryCta;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t14 || $[39] !== t15 || $[40] !== t16 || $[41] !== t17) {
    t18 = <GridRow className="grid md:!hidden"><GridColumn><div className="flex flex-col gap-6 py-10">{t13}{t14}{t15}{t16}{t17}</div></GridColumn></GridRow>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t11 || $[44] !== t12 || $[45] !== t18) {
    t19 = <>{t11}{t12}{t18}</>;
    $[43] = t11;
    $[44] = t12;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
};
export default HeroComponent;